import React, { Component, Fragment } from "react";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import {
  Mail,
  Lock,
  Eye,
  EyeOff,
  User,
  Phone,
  ArrowRight,
  AlertTriangle,
  X,
} from "react-feather";
import { withRouter } from "react-router-dom";

import {
  auth,
  createAdminProfileDocument,
  firestore,
} from "../../firebase/firebase.utils";
import { describeAuthError } from "./authErrors";
import "./login.css";
// One failure, said once, where the form is — not in a browser dialog that
// covers the page and has to be dismissed before the fields can be corrected.
const FormAlert = ({ error, onDismiss }) =>
  error ? (
    <div className="ars-alert" role="alert">
      <span className="ars-alert-icon" aria-hidden="true">
        <AlertTriangle size={15} />
      </span>
      <div className="ars-alert-text">
        <strong>{error.title}</strong>
        <span>{error.message}</span>
      </div>
      <button
        type="button"
        className="ars-alert-close"
        onClick={onDismiss}
        aria-label="Dismiss"
      >
        <X size={14} />
      </button>
    </div>
  ) : null;

export class LoginTabset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeShow: true,
      startDate: new Date(),
      loginEmail: "",
      loginPassword: "",
      registerEmail: "",
      registerPassword: "",
      registerConfirmPassword: "",
      registerStatus: "",
      registerMobileNo: "",
      loader: false,
      loginError: null,
      registerError: null,
      showLoginPassword: false,
      showRegisterPassword: false,
      showRegisterConfirmPassword: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.loginPasswordRef = React.createRef();
  }

  handleChange = (event) => {
    event.preventDefault();
    const { name, value } = event.target;
    // Editing a field is the answer to the message above it, so the message
    // goes as soon as they start — it must never sit there contradicting what
    // is now in the box.
    this.setState({
      [name]: value,
      ...(name.startsWith("login") ? { loginError: null } : { registerError: null }),
    });
  };

  toggleVisibility = (field) => {
    this.setState((prev) => ({ [field]: !prev[field] }));
  };

  handleLoginSubmit = async (event) => {
    event.preventDefault();

    const { loginEmail, loginPassword } = this.state;
    this.setState({ loader: true, loginError: null });
    try {
      await auth.signInWithEmailAndPassword(loginEmail, loginPassword);
      this.setState({ loginEmail: "", loginPassword: "", loader: false });
    } catch (error) {
      this.setState({ loader: false, loginError: describeAuthError(error) });
      // Put the cursor back where the correction is most likely to be made.
      // Without this it stays on the submit button and the next attempt starts
      // with a hunt for the field.
      if (this.loginPasswordRef.current) this.loginPasswordRef.current.focus();
    }
  };

  handleRegisterSubmit = async (event) => {
    event.preventDefault();
    const {
      registerEmail,
      registerPassword,
      registerConfirmPassword,
      registerStatus,
      registerDisplayName,
      registerMobileNo,
    } = this.state;
    if (registerPassword !== registerConfirmPassword) {
      this.setState({
        registerError: {
          title: "The two passwords are different",
          message:
            "Type the same password in both boxes, then create the account.",
        },
      });
      return;
    }

    this.setState({ registerError: null });
    try {
      const { user } = await auth.createUserWithEmailAndPassword(
        registerEmail,
        registerPassword,
      );

      await createAdminProfileDocument(user, {
        name: registerDisplayName,
        status: registerStatus,
        mobileNo: registerMobileNo,
        adminId: user.uid,
      });

      this.setState({
        registerDisplayName: "",
        registerEmail: "",
        registerPassword: "",
        registerConfirmPassword: "",
        registerMobileNo: "",
      });
      this.props.history.push("/dashboard");
    } catch (error) {
      this.setState({ registerError: describeAuthError(error) });
    }
  };

  render() {
    const {
      showLoginPassword,
      showRegisterPassword,
      showRegisterConfirmPassword,
    } = this.state;

    return (
      <div>
        <Fragment>
          <Tabs>
            <TabList className="ars-tablist">
              <Tab className="ars-tab">Login</Tab>
              {this.props.currentAdmin && (
                <Tab className="ars-tab">Register</Tab>
              )}
            </TabList>

            <TabPanel>
              <form
                className="ars-form"
                onSubmit={this.handleLoginSubmit}
              >
                <FormAlert
                  error={this.state.loginError}
                  onDismiss={() => this.setState({ loginError: null })}
                />

                <div className="ars-field">
                  <label htmlFor="loginEmail">Email address</label>
                  <div className="ars-input-row">
                    <Mail />
                    <input
                      required
                      name="loginEmail"
                      value={this.state.loginEmail}
                      onChange={this.handleChange}
                      type="email"
                      placeholder="you@arshipper.com"
                      id="loginEmail"
                    />
                  </div>
                </div>
                <div className="ars-field">
                  <label htmlFor="loginPassword">Password</label>
                  <div className="ars-input-row">
                    <Lock />
                    <input
                      required
                      name="loginPassword"
                      ref={this.loginPasswordRef}
                      value={this.state.loginPassword}
                      onChange={this.handleChange}
                      type={showLoginPassword ? "text" : "password"}
                      placeholder="••••••••"
                      id="loginPassword"
                    />
                    <button
                      type="button"
                      className="ars-visibility-btn"
                      onClick={() => this.toggleVisibility("showLoginPassword")}
                      aria-label={
                        showLoginPassword ? "Hide password" : "Show password"
                      }
                    >
                      {showLoginPassword ? <EyeOff size={16} /> : <Eye size={16} />}
                    </button>
                  </div>
                </div>

                <div className="ars-row-between">
                  <label className="ars-checkbox">
                    <input type="checkbox" id="chk-ani2" />
                    Keep me signed in
                  </label>
                  <a href="#" className="ars-link">
                    Forgot password?
                  </a>
                </div>

                <button
                  className="ars-submit"
                  type="submit"
                  disabled={this.state.loader}
                  aria-busy={this.state.loader}
                >
                  {this.state.loader ? (
                    <>
                      <span className="ars-spinner" aria-hidden="true" />
                      Signing in…
                    </>
                  ) : (
                    <>
                      Sign in
                      <ArrowRight />
                    </>
                  )}
                </button>
                <p className="ars-fineprint">
                  Access is limited to arshipper staff and verified partners.
                </p>
              </form>
            </TabPanel>
            {this.props.currentAdmin && (
              <TabPanel>
                <form
                  className="ars-form"
                  onSubmit={this.handleRegisterSubmit}
                >
                  <FormAlert
                    error={this.state.registerError}
                    onDismiss={() => this.setState({ registerError: null })}
                  />

                  <div className="ars-field">
                    <label htmlFor="registerDisplayName">Full name</label>
                    <div className="ars-input-row">
                      <User />
                      <input
                        required
                        name="registerDisplayName"
                        value={this.state.registerDisplayName}
                        onChange={this.handleChange}
                        type="text"
                        placeholder="Full name"
                        id="registerDisplayName"
                      />
                    </div>
                  </div>
                  <div className="ars-field">
                    <label htmlFor="registerMobileNo">Mobile number</label>
                    <div className="ars-input-row">
                      <Phone />
                      <input
                        required
                        name="registerMobileNo"
                        value={this.state.registerMobileNo}
                        onChange={this.handleChange}
                        type="number"
                        placeholder="01XXXXXXXXX"
                        id="registerMobileNo"
                      />
                    </div>
                  </div>
                  <div className="ars-field">
                    <label htmlFor="registerEmail">Email address</label>
                    <div className="ars-input-row">
                      <Mail />
                      <input
                        required
                        name="registerEmail"
                        value={this.state.registerEmail}
                        onChange={this.handleChange}
                        type="email"
                        placeholder="you@arshipper.com"
                        id="registerEmail"
                      />
                    </div>
                  </div>
                  <div className="ars-field">
                    <label htmlFor="registerPassword">Password</label>
                    <div className="ars-input-row">
                      <Lock />
                      <input
                        required
                        name="registerPassword"
                        value={this.state.registerPassword}
                        onChange={this.handleChange}
                        type={showRegisterPassword ? "text" : "password"}
                        placeholder="••••••••"
                        id="registerPassword"
                      />
                      <button
                        type="button"
                        className="ars-visibility-btn"
                        onClick={() =>
                          this.toggleVisibility("showRegisterPassword")
                        }
                        aria-label={
                          showRegisterPassword
                            ? "Hide password"
                            : "Show password"
                        }
                      >
                        {showRegisterPassword ? (
                          <EyeOff size={16} />
                        ) : (
                          <Eye size={16} />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="ars-field">
                    <label htmlFor="registerConfirmPassword">
                      Confirm password
                    </label>
                    <div className="ars-input-row">
                      <Lock />
                      <input
                        required
                        name="registerConfirmPassword"
                        value={this.state.registerConfirmPassword}
                        onChange={this.handleChange}
                        type={showRegisterConfirmPassword ? "text" : "password"}
                        placeholder="••••••••"
                        id="registerConfirmPassword"
                      />
                      <button
                        type="button"
                        className="ars-visibility-btn"
                        onClick={() =>
                          this.toggleVisibility("showRegisterConfirmPassword")
                        }
                        aria-label={
                          showRegisterConfirmPassword
                            ? "Hide password"
                            : "Show password"
                        }
                      >
                        {showRegisterConfirmPassword ? (
                          <EyeOff size={16} />
                        ) : (
                          <Eye size={16} />
                        )}
                      </button>
                    </div>
                  </div>
                  <div className="ars-field">
                    <label htmlFor="registerStatus">Admin status</label>
                    <div className="ars-input-row">
                      <User />
                      <select
                        name="registerStatus"
                        value={this.state.registerStatus}
                        onChange={this.handleChange}
                        required
                        id="registerStatus"
                      >
                        <option value="">Select admin status</option>
                        <option value="Admin">Admin</option>
                        <option value="Accounts">Accounts</option>
                        <option value="Employee">Employee</option>
                        <option value="Officer">Officer</option>
                      </select>
                    </div>
                  </div>
                  <p className="ars-terms">
                    <label className="ars-checkbox">
                      <input
                        className="checkbox_animated"
                        id="chk-ani3"
                        type="checkbox"
                      />
                      I agree to the <a href="#">terms &amp; conditions</a>
                    </label>
                  </p>
                  <button className="ars-submit" type="submit">
                    Create account
                    <ArrowRight />
                  </button>
                </form>
              </TabPanel>
            )}
          </Tabs>
        </Fragment>
      </div>
    );
  }
}

export default withRouter(LoginTabset);
